<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <div v-if="loaded">
          <v-select
              :items="filterItems"
              @input="filterEvent"
              label="Filter"
              v-model="filterSelected"
              single-line/>
          <div v-if="data.length > 0">
            <v-card tile v-for="item in data" :key="item.id" class="mb-2" :class="item.tableName === 'sppd.tb_sppd'?'request':'realization'">
              <v-card-text>
                <router-link :to="{name: 'business-trip-worklist', params: {worklistid: item.id}}">
                <h3>{{item.title}}</h3>
                From User {{item.fromUser.name}} ( {{item.fromUser.nik}} ) | Level : {{item.level}}
                | {{item.createdTime | moment('DD MMM YYYY HH:mm')}} | {{item.editable | uppercase()}}
                </router-link>
              </v-card-text>
            </v-card>
          </div>
          <h2 v-else>No Worklist</h2>
        </div>
        <div v-else>
          <h2>Loading...</h2>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vuex from 'vuex'

const employeeStore = Vuex.createNamespacedHelpers('Employee')
const worklistStore = Vuex.createNamespacedHelpers('Worklist')

export default {
  name: 'Worklist',
  data () {
    return {
      loaded: false,
      data: [],
      fulldata: [],
      title: 'Worklist',
      filterSelected: 'ALL',
      filterItems: ['ALL', 'Request', 'Realization'],
      actions: [{tooltip: 'Refresh', icon: 'refresh', handler: this.refresh}]
    }
  },
  computed: {
    ...employeeStore.mapState({
      employees: 'items'
    }),
    employee () {
      const results = this.employees.filter(x => x.nik === this.$store.state.login.username)
      return results.length > 0 ? results[0] : {}
    }
  },
  methods: {
    ...employeeStore.mapActions({
      list: 'list'
    }),
    ...worklistStore.mapActions({
      getApprovalByToUser: 'getApprovalByToUser'
    }),
    filterEvent (val) {
      if (val === 'ALL') {
        this.data = this.fulldata
      } else if (val === 'Request') {
        this.data = this.fulldata.filter(tmp => tmp.tableName === 'sppd.tb_sppd')
      } else {
        this.data = this.fulldata.filter(tmp => tmp.tableName === 'sppd.tb_sppd_real')
      }
    },
    loadResources () {
      const self = this
      self.loaded = false
      self.list({vueinstance: self})
        .then(res => {
          if (typeof self.employee.empId !== 'undefined') {
            self.getApprovalByToUser({vueinstance: self, empid: self.employee.empId})
              .then(res1 => {
                self.fulldata = res1
                self.data = res1
                self.loaded = true
              }).catch(err1 => self.$error(err1))
          } else {
            self.loaded = true
          }
        }).catch(err => self.$error(err))
    },
    refresh () {
      this.loadResources()
    },
    _setup () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.actions)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.loadResources()
      vm._setup()
    })
  }
}
</script>

<style scoped>
  a {
    color: black;
  }
  .request{
    border-left: 5px solid #2196f3;
  }
  .realization{
    border-left: 5px solid #FF5722;
  }
</style>



// WEBPACK FOOTER //
// src/components/bt-worklist/Worklist.vue